<template>
  <div class="circle-progress">
    <v-progress-circular
      :color="color"
      :width="width"
      :size="size"
      rotate="270"
      :value="progress"
      :indeterminate='isAnimateProgress'
    />
  </div>
</template>

<script>
export default {
  name: 'CircleProgress',
  props: {
    progress: {
      required: true,
      default: 0,
    },
    color: {
      type: String,
      default: '#56C228',
    },
    width: {
      type: Number,
      default: 2,
    },
    size: {
      type: Number,
      default: 20.5,
    },
  },
  computed: {
    isAnimateProgress() {
      return !(this.progress === 100);
    },
  },
};
</script>

<style lang="scss" scoped>
  .circle-progress {
    position: relative;
  }
</style>
